import { useState, useEffect } from 'react'
import './ThinkingIndicator.css'

const THINKING_PHRASES = [
  'Thinking',
  'Analyzing',
  'Researching',
  'Processing',
  'Crafting',
]

function ThinkingIndicator() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true)
      
      // After fade out, change the word
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % THINKING_PHRASES.length)
        setIsAnimating(false)
      }, 200)
    }, 2000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="thinking-indicator">
      <span className={`thinking-text ${isAnimating ? 'fade-out' : 'fade-in'}`}>
        {THINKING_PHRASES[currentIndex]}
      </span>
      <span className="thinking-dots">
        <span className="dot">.</span>
        <span className="dot">.</span>
        <span className="dot">.</span>
      </span>
    </div>
  )
}

export default ThinkingIndicator
